import {isEmpty} from '@shared/helpers/lang'

import {ProductClass, ProductType} from '@web/core/constants'
import makeSlice from '@web/slices/orderSheetProducts/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (_, {payload}) => {
            const {
                data: {products},
            } = payload

            return products.map((product, index) => {
                return {
                    id: product.productOrderNo,
                    name: product.productName,
                    url: product.productUrl,
                    type: ProductType.NORMAL,
                    imageUrl: product.productImageUrl,
                    unitPrice: product.productUnitPrice ?? 0,
                    // items 로 해결이 가능하다면 제거
                    quantity: product.orderQuantity,
                    orderAmount: product.totalOrderAmount,
                    naverBenefit: product.naverBenefit,
                    customOrderDetailType: null,
                    preOrder: null,
                    merchantInfo: {
                        merchantProductId: product.merchantProductId,
                        merchantNo: product.merchantNo,
                        merchantChannelName: product.merchantChannelName,
                        merchantChannelServiceType: product.merchantChannelServiceType,
                    },
                    deliveryInfo: {
                        deliveryGroupKey: product.deliveryGroupKey,
                        deliveryAttributeType: null,
                        overseasDelivery: product.overseasDelivery,
                        branch: null,
                        todayDispatch: null,
                        hopeDelivery: null,
                        deliveryPrediction: null,
                    },
                    items: isEmpty(product.items)
                        ? [
                              {
                                  orderSheetItemId: `${product.productOrderNo}-${index}`,
                                  productClassType: ProductClass.SINGLE,
                                  itemNo: `${product.productOrderNo}-${index}`,
                                  price: product.productUnitPrice ?? 0,
                                  quantity: product.orderQuantity,
                                  orderAmount: product.totalOrderAmount,
                                  optionContents: '',
                                  branchId: null,
                                  branchBenefitType: null,
                                  branchBenefitValue: null,
                                  branchBenefitApplyValue: null,
                                  elements: [],
                              },
                          ]
                        : product.items.map((item) => {
                              return {
                                  orderSheetItemId: item.productOrderNo,
                                  productClassType: item.productClassType,
                                  itemNo: item.productOrderNo,
                                  price: item.price,
                                  quantity: item.quantity,
                                  orderAmount: item.orderAmount,
                                  optionContents: item.optionContents,
                                  branchId: null,
                                  branchBenefitType: null,
                                  branchBenefitValue: null,
                                  branchBenefitApplyValue: null,
                                  elements: item.elements,
                              }
                          }),
                    gift: product.gift,
                    cupDeposit: null,
                    ecouponBarcodeConnect: null,
                    arrivalGuaranteeDateTime: null,
                    arrivalGuaranteeCheckedDateTime: null,
                    rmid: null,
                    outboundLocationId: null,
                    installationProduct: null,
                }
            })
        })
    },
})

export default slice.reducer
